module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_summary02-4e2862eb1072b838689b26163389ffbb.png";